import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';
import { Td, Tr, MultiSiteTag } from './css';

const Row = ({
  keys,
  row,
  rowIndex,
  getFeilds,
  actions,
  dataModel,
  actionsDisplay
}) => {
  const { groupId, groupRecords } = row;
  const [open, setOpen] = useState(false);
  const [sites, setSitesList] = useState([]);

  useEffect(() => {
    if (groupId) {
      const temp = [row].concat(groupRecords);
      temp.sort((a, b) => (a.currentSite > b.currentSite && 1) || -1);

      setSitesList(temp);
    }
  }, [groupId]);

  const renderParentRow = () => {
    const { businessLegalName } = row;
    return (
      <Tr
        isParent
        style={{ background: rowIndex % 2 === 0 ? '#f9f1ff' : '#ffffff' }}
        onClick={() => setOpen(!open)}
      >
        <Td style={{ borderRight: '1px solid #e7e7e7' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            {`${groupId || '------'}`}
            <MultiSiteTag>Multi site</MultiSiteTag>
          </div>
        </Td>
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td
          style={{ borderRight: '1px solid #e7e7e7' }}
        >{`${businessLegalName || '------'}`}</Td>
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td style={{ borderRight: '1px solid #e7e7e7' }} />
        <Td style={{ textAlign: 'center', cursor: 'pointer' }}>
          {open ? <MdExpandLess size={20} /> : <MdExpandMore size={20} />}{' '}
        </Td>
      </Tr>
    );
  };

  const renderChildRow = (data, rIndex, isChildRow) => {
    const rowData =
      // eslint-disable-next-line new-cap
      (dataModel && dataModel.length && new dataModel(data)) || data;
    const rowKey = `row${rIndex}`;
    return (
      <Tr key={rowKey} isChildRow={isChildRow} isOdd={rIndex % 2 === 0}>
        {keys.map((cell, cellIndex) => {
          const cellKey = `cell${rIndex}.${cellIndex}`;
          return cell !== 'actions' ? (
            <Td key={cellKey} style={{ borderRight: '1px solid #e7e7e7' }}>
              {getFeilds(cell, cellKey, data, rowData, isChildRow)}
            </Td>
          ) : (
            <Td actionsDisplay={actionsDisplay} actionStyles key={cellKey}>
              {actions(data)}
            </Td>
          );
        })}
      </Tr>
    );
  };

  return (
    <>
      {groupId ? (
        <>
          {' '}
          {renderParentRow()}
          {open && (
            <>
              {sites && sites.length ? (
                sites.map((data, index) => renderChildRow(data, index, true))
              ) : (
                <></>
              )}
            </>
          )}
        </>
      ) : (
        <>{renderChildRow(row, rowIndex, false)}</>
      )}
    </>
  );
};

Row.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  row: PropTypes.objectOf(PropTypes.object).isRequired,
  rowIndex: PropTypes.number.isRequired,
  getFeilds: PropTypes.func.isRequired,
  actions: PropTypes.func.isRequired,
  dataModel: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  actionsDisplay: PropTypes.string
};

Row.defaultProps = {
  dataModel: {},
  actionsDisplay: 'flex'
};

export default Row;
